import React from 'react';
import Immutable from 'immutable';
import { getComponentForState } from './moduleregistry';


export default class Module extends React.PureComponent {

	render() {
		const Component = getComponentForState(this.props.appState);
		if (!Component) {
			return null;
		}
		return <Component
			{...this.props}
			data={this.props.appState.get('data')}
		/>;
	}
}
